module.exports = {
  "listings.accuracy": "Name, Address and Phone"
};
